import {useEffect, useState} from 'react';
import Character from 'assets/images/characters/CarolinaMariadeJesus/speaking-default.webp';
import {Button, Modal} from 'letrus-ui';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import styles from './ZeroGradeModal.module.scss';

export interface ZeroGradeModalProps {
  id: string;
  onClose(): void;
}

const ZERO_WARNING_ANIMATION_SPEED_IN_MILLISECONDS = 30;
const MAIN_BUTTON_SUSPENSION_TIME_IN_MILLISECONDS = 2000;

function ZeroGradeModal({id, onClose}: ZeroGradeModalProps): JSX.Element {
  const [commentAnimation, setCommentAnimation] = useState('');
  const [shouldStopAnimation, setShouldStopAnimation] = useState(false);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const zeroGradeWarning =
    'Atribuí ao seu texto a nota zero. Vamos entender juntos as razões.';

  useEffect(() => {
    setCommentAnimation('');

    let currentCharacter = 0;

    const interval = setInterval(() => {
      setCommentAnimation(
        (prevText) => prevText + zeroGradeWarning[currentCharacter],
      );

      currentCharacter += 1;

      if (currentCharacter === zeroGradeWarning.length) {
        clearInterval(interval);
      }
    }, ZERO_WARNING_ANIMATION_SPEED_IN_MILLISECONDS);

    setTimeout(() => {
      setIsButtonEnabled(true);
    }, MAIN_BUTTON_SUSPENSION_TIME_IN_MILLISECONDS);

    return () => clearInterval(interval);
  }, [zeroGradeWarning]);

  return (
    <Modal id={id}>
      <section className={styles.container}>
        <h3>Análise concluída</h3>

        <article className={styles.commentContainer}>
          <img src={Character} alt="Carolina MariadeJesus" />

          <button
            className={styles.currentComment}
            type="button"
            onClick={() => setShouldStopAnimation(true)}
          >
            {shouldStopAnimation ? zeroGradeWarning : commentAnimation}
          </button>
        </article>

        <Button onClick={onClose} disabled={!isButtonEnabled}>
          <FontAwesomeIcon icon="eye" />
          Ver correção
        </Button>
      </section>
    </Modal>
  );
}

export default ZeroGradeModal;
